const COLORS = [
  "#f97316",
  "#0ea5e9",
  "#10b981",
  "#8b5cf6",
  "#f43f5e",
  "#22c55e",
  "#eab308",
  "#14b8a6",
];

const normalizeValue = (value) => (value || "").trim().toLowerCase();

const hashString = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const pickColor = (seed) => {
  const hash = hashString(seed || "user");
  return COLORS[hash % COLORS.length];
};

const getInitials = (value) => {
  const raw = (value || "").trim();
  if (!raw) return "U";
  const base = raw.includes("@") ? raw.split("@")[0] : raw;
  const cleaned = base.replace(/[^a-zA-Z0-9\s]/g, " ").trim();
  if (!cleaned) return "U";
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const buildSvgDataUrl = (initials, bg) => {
  const safeInitials = (initials || "U").slice(0, 2).toUpperCase();
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><rect width="96" height="96" fill="${bg}"/><text x="50%" y="54%" text-anchor="middle" dominant-baseline="middle" font-family="Arial, sans-serif" font-size="38" fill="#ffffff">${safeInitials}</text></svg>`;
  if (typeof window === "undefined" || typeof window.btoa !== "function") {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }
  return `data:image/svg+xml;base64,${window.btoa(svg)}`;
};

export const getAvatarUrl = ({ photoURL, email, name } = {}) => {
  const direct = (photoURL || "").trim();
  if (
    direct &&
    direct !== "/images/imgaine1.svg" &&
    !direct.endsWith("/images/imgaine1.svg")
  ) {
    return direct;
  }
  const seed = normalizeValue(email) || normalizeValue(name);
  if (!seed) return "/images/imgaine1.svg";
  const initials = getInitials(name || email || "");
  const bg = pickColor(seed);
  return buildSvgDataUrl(initials, bg);
};
